import {
    MatrixData,
    MatrixItem,
    newCell,
    newMatrixData,
    newMatrixItem,
    TransformedMatrixItem,
} from '@/pages/Farming/types';

export function fillMissingCells(data: MatrixData): newMatrixData {
  const { columnsCount, rowsCount, individualsTable } = data;

  const cellMap = new Map();
  const indivWithLocation = new Set<string>();

  individualsTable.forEach((row: MatrixItem) => {
    row.cells.forEach((cell) => {
      const key = `${cell.rowIndex}-${cell.columnIndex}`;
      cellMap.set(key, cell);
      indivWithLocation.add(cell.individualInventoryNumber);
    });
  });

  const newIndividualsTable: newMatrixItem[] = [];

  for (let rowIndex = 0; rowIndex < rowsCount; rowIndex++) {
    const row: newMatrixItem = {
      rowIndex,
      cells: [],
    };

    for (let columnIndex = 0; columnIndex < columnsCount; columnIndex++) {
      const key = `${rowIndex}-${columnIndex}`;
      const existingCell = cellMap.get(key);

      if (existingCell) {
        row.cells.push(existingCell);
      } else {
        row.cells.push({
          columnIndex,
          rowIndex,
        });
      }
    }

    newIndividualsTable.push(row);
  }

  return {
    ...data,
    individualsTable: newIndividualsTable,
    indivWithLocation,
  };
}

export const transformToTable = (individualsTable: newMatrixItem[]) =>
  individualsTable.map((item) => {
    const columns: Record<string, newCell> = {};

    item.cells.forEach((cell: newCell) => {
      columns[`columnIndex${cell.columnIndex}`] = cell;
    });

    return {
      rowIndex: item.rowIndex,
      ...columns,
    } as TransformedMatrixItem;
  });
